export const addLocalStorage = (key: string, value: any) => {
  return new Promise<void>((resolve, reject) => {
    try {
      localStorage.setItem(key, value)
      resolve()
    } catch (e) {
      reject(e)
    }
  })
}

export const getLocalStorage = (key: string) => {
  return localStorage.getItem(key)
}

export const removeLocalStorage = (key: string) => {
  return localStorage.removeItem(key)
}
